import ElcFolderType from 'owa-service/lib/contract/ElcFolderType';
import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';

/**
 * Helper to get folder type from  distinguishedFolderId
 * @param distinguishedFolderId
 */
export default function getFolderTypeFromDistinguishedFolderId(
    distinguishedFolderId: DistinguishedFolderIdName
): ElcFolderType {
    switch (distinguishedFolderId) {
        case 'msgfolderroot':
        case 'archivemsgfolderroot':
            return ElcFolderType.All;
        case 'deleteditems':
        case 'archivedeleteditems':
            return ElcFolderType.DeletedItems;
        case 'recoverableitemsdeletions':
        case 'archiverecoverableitemsdeletions':
            return ElcFolderType.RecoverableItems;
        case 'calendar':
            return ElcFolderType.Calendar;
        case 'contacts':
            return ElcFolderType.Contacts;
        case 'conversationhistory':
            return ElcFolderType.ConversationHistory;
        case 'drafts':
            return ElcFolderType.Drafts;
        case 'inbox':
            return ElcFolderType.Inbox;
        case 'junkemail':
            return ElcFolderType.JunkEmail;
        case 'journal':
            return ElcFolderType.Journal;
        case 'notes':
            return ElcFolderType.Notes;
        case 'outbox':
            return ElcFolderType.Outbox;
        case 'sentitems':
            return ElcFolderType.SentItems;
        case 'syncissues':
            return ElcFolderType.SyncIssues;
        case 'tasks':
            return ElcFolderType.Tasks;
        case 'none':
        default:
            return ElcFolderType.Personal;
    }
}
